export default class ErrorCodes {
  static ACCOUNT_NOTFOUND = "A00001";
  static ACCOUNT_PERMISSION_ERROR = "AC0003";
  static EMPTY_CHATSETTING_ERROR = "CHS0001";
  static PROJECT_LIMIT_ERROR = "AC0011";
}
